
type JobStatus = 'All' | 'Started' | 'Completed' | 'Failed';

export interface JobStatMenuItem {
    label: string;
    value: string;
    icon:string;
    color: string;
    status?: JobStatus;
    navigate: boolean;
}

export const jobStatStatusLabelMap: Record<JobStatus, string> = {
    All: 'Total Jobs Executed',
    Started: 'Running Jobs',
    Completed: 'Successful Jobs',
    Failed: 'Failed Jobs'
};
